import React, { Component } from 'react';
import _ from 'lodash';
import setupApi from '../libs/Api';
import config from '../config';
import File from '../libs/File';
import Table from '../components/Table';

export default class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: `Document Portal`,
      isLoading: true,
      files: [],
      currentPath: props.path,
      topPath: props.path,
      hideAddFolder: true,
      hideUpload: true,
      hideUploadInfoSeries: true,
      filesAPI: {},
      breadcrumbs: []
    };

    this.handleAddFolderClick = this.handleAddFolderClick.bind(this);
    this.handleUploadClick = this.handleUploadClick.bind(this);
    this.handleUploadInfoSeriesClick = this.handleUploadInfoSeriesClick.bind(this);
  }

  async componentDidMount() {
    if (!this.props.isAuthenticated) {
      return;
    }

    // Setup API
    const api = setupApi(config.baseUrl, this.props.keyValue, this.props.path);
    this.state.filesAPI = new File(api);

    let res = await this.state.filesAPI.getFiles();
    this.setState({ currentPath: this.props.path });
    
    const { path } = this.props;
    let title = `Document Portal`;
    let pathSplit = path.split('/');
    let customerIndex = pathSplit
      .map(pathName => pathName.toLowerCase())
      .indexOf('customer');

    title = customerIndex > 0 ? pathSplit[customerIndex - 1] : title;

    // Add a name field with removes the path
    const files = this.cleanUpFiles(res.files, this.props.path);

    try {
      this.setState({
        files: files,
        title
      });
    } catch (e) {
      console.log(e);
    }
    const crumbs = this.state.breadcrumbs;
    crumbs.push({
      key: 0,
      path: this.props.path,
      label: 'Home'
    });

    this.setState({ isLoading: false, breadcrumbs: crumbs });
  }

  cleanUpFiles(files, base) {
    // Add a name field with removes the path
    return files.map(fileObj => {
      fileObj.name = fileObj.path.replace(base, '').replace('/', '');
      return fileObj;
    });
  }

  handlerClick = async file => {
    this.setState({ isLoading: true });

    // If clicked a folder then get the child files
    if (file.type === 'folder') {
      try {
        console.log(file);
        this.setState({ currentPath: file.path });
        await this.updateFiles(file.path);
      } catch (e) {
        console.log(e);
        this.setState({ files: [] });
      }

      const lastCrumb = _.last(this.state.breadcrumbs);

      // Add to breadcrumb
      const crumbs = this.state.breadcrumbs;
      crumbs.push({
        key: lastCrumb.key + 1,
        label: file.name,
        path: file.path
      });

      this.setState({ breadcrumbs: crumbs });
    } else {
      // Charles Story 7602 pop-up blocker support
      // open window synchronously before we know the URL
      const win = window.open(process.env.PUBLIC_URL + '/__static/loading.html', '_blank');
      window.focus();
      var p = new Promise((resolve,reject)=>{
        // in IE11, event listeners can't be added to windows not yet loaded
        if (win && win.addEventListener && !(window.navigator.userAgent.indexOf("MSIE")>0) && !navigator.userAgent.match(/Trident\/7\./) ){
          win.addEventListener('load', ()=>{
            resolve();
          },true);  
        }
        else {resolve()};
      });
      
      // If a file then download via the redirect url
      const res = await this.state.filesAPI.getDownloadURL(file.path);
      const url = res.url;
      // if the loading page hasn't finished loading yet, wait for that too
      await p;

      //const win = window.open(url, '_blank');
      if (win && win.redirectTo) {
        // Charles Story 7602 pop-up blocker support
        // push the URL to the previously created window
        if (win.redirectTo){
          win.redirectTo(url);
        }
        else {
          win.location.replace(url);
        }
      } else {
        alert('Please allow new popups to download file');
      }
    }

    this.setState({ isLoading: false });
  };

  async updateFiles(path) {
    this.setState({ isLoading: true });
    const res = await this.state.filesAPI.getChildFiles(path);
    const files = this.cleanUpFiles(res.files, path);
    this.setState({ files: files });
  }

  async handleBreadCrumbClick(link) {
    this.setState({ isLoading: true });
    // Update state of selected level
    const selectedKey = link.key;
    const newCrumbs = _.filter(this.state.breadcrumbs, crumb => {
      return selectedKey >= crumb.key;
    });

    this.setState({ breadcrumbs: newCrumbs, currentPath: link.path });
    await this.updateFiles(link.path);
    this.setState({ isLoading: false });
  }

  /**
   * Create a new folder in S3
   *
   * @param path
   * @returns {Promise<void>}
   */
  async handleNewFolder(path) {
    this.setState({ isLoading: true });
    path = this.state.currentPath + path + '/';
    try {
      await this.state.filesAPI.addPath(path);
      await this.updateFiles(this.state.currentPath);
      this.handleAddFolderClick();
    } catch (e) {
      console.log(e);
    }

    this.setState({ isLoading: false });
  }

  /**
   * Handles state change for clicking the add folder button
   */
  handleAddFolderClick() {
    this.setState({ hideAddFolder: !this.state.hideAddFolder });
  }

  /**
   * Handles a state change for clicking the upload button
   */
  handleUploadClick() {
    this.setState({ hideUpload: !this.state.hideUpload });
  }

  /**
   * Handles a state change for clicking the Upload Info Series button
   */
   async handleUploadInfoSeriesClick() {
    this.setState({ hideUploadInfoSeries: !this.state.hideUploadInfoSeries });
    if(!this.state.hideUploadInfoSeries)return;
    this.setState({ isLoading: true });
    try {
      let res = await this.state.filesAPI.getInfoSeries();
      res.files.map((file)=>(file.name= file.path.split('/').pop()));
      console.log(res);
      this.setState({ infoSeriesFiles: res.files });
    } catch (e) {
      console.log(e);
    }
    this.setState({ isLoading: false });
  }

  async handleUploadInfoSeriesCancelClick(){
    this.setState({ hideUploadInfoSeries: true });
  }

  /**
   * Deletes an object form APW
   *
   * @param path
   * @returns {Promise<void>}
   */
  async handleDeleteClick(path) {
    this.setState({ isLoading: true });
    try {
      await this.state.filesAPI.deletePath(path);
      await this.updateFiles(this.state.currentPath);
    } catch (e) {
      console.log(e);
    }
    this.setState({ isLoading: false });
  }

  /**
   * Renames an object on aws
   *
   * @param from
   * @param to
   * @returns {Promise<void>}
   */
  async handleRenameClick(from, to) {
    this.setState({ isLoading: true });
    to = this.state.currentPath + to;
    try {
      await this.state.filesAPI.rename(from, to);
      await this.updateFiles(this.state.currentPath);
    } catch (e) {
      await this.updateFiles(this.state.currentPath);
      console.log(e);
    }
    this.setState({ isLoading: false });
  }

  /**
   * Copies object in AWS
   *
   * @param from
   * @param to
   * @returns {Promise<void>}
   */
  async handleCopyClick(from, to) {
    this.setState({ isLoading: true });
    //if (currentDir) {
    to = this.state.currentPath + to;
    //}

    try {
      await this.state.filesAPI.copy(from, to);
      await this.updateFiles(this.state.currentPath);
    } catch (e) {
      await this.updateFiles(this.state.currentPath);
      console.log(e);
    }
    this.setState({ isLoading: false });
  }

  async upload(files) {
    this.setState({ isLoading: true });
    try {
      for (let i=0; i<files.length; i++) {
        const filePath = this.state.currentPath + files[i].name;
        // Get PUT url
        const res = await this.state.filesAPI.getUploadURL(filePath);
        // Upload File
        await this.state.filesAPI.upload(files[i], res.url);
      }
      // Refresh data
      await this.updateFiles(this.state.currentPath);
    } catch (e) {
      console.log(e);
    }
    this.setState({ isLoading: false });
  }

  async uploadInfoSeries(files){
    this.setState({ isLoading: true });
    let currentPath = this.state.currentPath.endsWith('/') ? this.state.currentPath.slice(0,-1) : this.state.currentPath;
    try {
 
      await this.state.filesAPI.copyFromInfoSeries(files.map((f)=>(f.name)), currentPath);
      
      await this.updateFiles(this.state.currentPath);
    } catch (e) {
      await this.updateFiles(this.state.currentPath);
      console.log(e);
    }
    this.setState({ isLoading: false });
    //sample copyFromInfoSeries('sample.pdf', 'Franchise_Account_Real_Use_this_one_0lQAH/Inspection_004-1810/invoice');
  }

  renderFilesTable() {
    return (
      <Table
        files={this.state.files}
        infoSeriesFiles={this.state.infoSeriesFiles}
        onClick={path => this.handlerClick(path)}
        breadcrumbs={this.state.breadcrumbs}
        onBreadCrumbClick={link => this.handleBreadCrumbClick(link)}
        handleChangeFolder={path => this.handleNewFolder(path)}
        hideAddFolder={this.state.hideAddFolder}
        addFodlerCancel={() => this.handleAddFolderClick()}
        hideUpload={this.state.hideUpload}
        hideUploadInfoSeries={this.state.hideUploadInfoSeries}
        uploadCancel={() => this.handleUploadClick()}
        uploadInfoSeriesCancel={() => this.handleUploadInfoSeriesCancelClick()}
        onDelete={path => this.handleDeleteClick(path)}
        onRename={(from, to) => this.handleRenameClick(from, to)}
        onCopy={(from, to, currentDir) =>
          this.handleCopyClick(from, to, currentDir)
        }
        handleUpload={files => this.upload(files)}
        handleUploadInfoSeries={files => this.uploadInfoSeries(files)}
        {...this.props}
      />
    );
  }

  renderLoading() {
    return (
      <div className="loading-container">
        <i className="fa fa-spinner fa-5x fa-spin" aria-hidden="true" />
      </div>
    );
  }

  renderBody() {
    if (this.state.isLoading) {
      return this.renderLoading();
    } else {
      return this.renderFilesTable();
    }
  }

  render() {
    const { isCustomerView } = this.props;

    return (
      <div>
        <header>
          {!isCustomerView && (
            <div id="toolbar">
              <button
                id="btn-folder"
                className="btn"
                onClick={this.handleAddFolderClick}
              >
                <i className="fa fa-plus fa-fw" /> New Folder
              </button>
              <button
                id="btn-upload"
                className="btn"
                onClick={this.handleUploadClick}
              >
                <i className="fa fa-upload fa-fw" /> Upload
              </button>
              <button
                id="btn-upload"
                className="btn"
                onClick={this.handleUploadInfoSeriesClick}
              >
                 Upload Info Series
              </button>
            </div>
          )}
          <h1>{this.state.title}</h1>
          <span className="clearfix" />
        </header>
        {this.renderBody()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home.js